<template>
  <div class="container py-5">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card shadow-sm p-4">
          <h3 class="text-center mb-4">My Account</h3>

          <!-- ✅ Profile Details View -->
          <div v-if="!isEditing">
            <ul class="list-group list-group-flush mb-3">
              <li class="list-group-item d-flex justify-content-between">
                <strong>Name:</strong> <span>{{ user?.first_name }} {{ user?.last_name }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <strong>Email:</strong> <span>{{ user.email }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <strong>Mobile No.:</strong> <span>{{ user.mobile_no || '' }}</span>
              </li>
              <!-- <li class="list-group-item d-flex justify-content-between">
                <strong>Phone No.:</strong> <span>{{ user.phone || '-' }}</span>
              </li> -->
            </ul>
            <h5 class="mt-4 mb-3" style="color: #0d6efd;">Billing Address</h5>
            <ul class="list-group list-group-flush mb-3">
              <li class="list-group-item d-flex justify-content-between">
                <strong>Address 1:</strong> <span>{{ user?.address1 || '-' }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <strong>Address 2:</strong> <span>{{ user?.address2 || '-' }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <strong>City:</strong> <span>{{ user?.billing_city || '-' }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <strong>State:</strong> <span>{{ user?.billing_state || '-' }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <strong>Zipcode:</strong> <span>{{ user?.zipcode || '-' }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <strong>Country:</strong> <span>Australia</span>
              </li>
            </ul>

            <div class="text-center">
              <button class="btn btn-primary" @click="startEdit">
                <i class="bi bi-pencil-square me-1"></i> Edit
              </button>
            </div>
          </div>

          <!-- ✅ Edit Form View -->
          <div v-else>
            <form @submit.prevent="saveProfile">
              <div class="mb-3">
                <label class="form-label">Firstname</label>
                <input v-model="user.first_name" type="text" class="form-control" required>
              </div>

              <div class="mb-3">
                <label class="form-label">Lastname</label>
                <input v-model="user.last_name" type="text" class="form-control" required>
              </div>

              <div class="mb-3">
                <label class="form-label">Email</label>
                <input v-model="user.email" type="email" class="form-control" required>
              </div>

              <div class="mb-3">
                <label class="form-label">Mobile No.</label>
                <input v-model="user.mobile_no" type="text" class="form-control">
              </div>

              <!-- <div class="mb-3">
                <label class="form-label">Phone No.</label>
                <input v-model="user.phone" type="text" class="form-control">
              </div> -->
              
              <h5 class="mt-4 mb-3" style="color: #0d6efd;">Billing Address</h5>

              <div class="mb-3">
                <label class="form-label">Address 1</label>
                <input v-model="user.address1" type="text" class="form-control">
              </div>

              <div class="mb-3">
                <label class="form-label">Address 2</label>
                <input v-model="user.address2" type="text" class="form-control">
              </div>

              <div class="mb-3">
                <label class="form-label">City</label>
                <input v-model="user.billing_city" type="text" class="form-control">
              </div>

              <div class="mb-3">
                <label class="form-label">State</label>
                <input v-model="user.billing_state" type="text" class="form-control">
              </div>

              <div class="mb-3">
                <label class="form-label">Zipcode</label>
                <input v-model="user.zipcode" type="text" class="form-control">
              </div>

              <div class="d-flex justify-content-between">
                <button class="btn btn-success" type="submit">
                  <i class="bi bi-check-circle me-1"></i> Save
                </button>
                <button class="btn btn-secondary" type="button" @click="cancelEdit">
                  <i class="bi bi-x-circle me-1"></i> Cancel
                </button>
              </div>
            </form>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { api } from '@/plugins/axios'
import { useAuthStore } from '@/stores/authStore'
import { storeToRefs } from 'pinia'
import { ref, reactive } from 'vue'
import { toast } from 'vue3-toastify'

const store = useAuthStore()
const { user } = storeToRefs(store)
const isEditing = ref(false)

function startEdit() {  
  isEditing.value = true
}

function cancelEdit() {
  isEditing.value = false
}

function saveProfile() {  
  api.post(`update-profile`, user.value).then((response) => {
    user.value.is_first_online_order = response.data.results.is_first_online_order
    localStorage.setItem('user', JSON.stringify(response.data.results))
    toast.success('Profile updated successfully!')
  }).catch((e) => {
    console.error(e)
  }).finally(() => {
    isEditing.value = false
  })
}
</script>

<style scoped>
.card {
  border-radius: 15px;
  background-color: #ffffff;
}

h3 {
  color: #0d6efd;
  font-weight: 600;
}

.list-group-item {
  font-size: 1rem;
  border: none;
  border-bottom: 1px solid #f1f1f1;
}

.list-group-item:last-child {
  border-bottom: none;
}

.form-label{
   position: static;
}
</style>
